module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAPAAAAACCAYAAABmD1GAAAAAF0lEQVR42mNgGAWjYBSMglEwCkYB/QEAB4IAAcZ9XHIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/transparent.png
// module id = 683
// module chunks = 1